class ShippingBar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.render("desktop");
        this.render("mobile");
    }

    render(modifier) {
        let shippingBar = document.getElementById(`shippingBar__bar--${modifier}`);

        if (shippingBar === null) {
            return;
        }

        // Get cart weight in grams and convert it to kilograms only for display
        const totalWeightInGrams = parseFloat(shippingBar.dataset.weight);
        const totalWeightInKg = (totalWeightInGrams / 1000).toFixed(2);
        const shippingBar_Steps = shippingBar.querySelectorAll(`.shippingBar__step--${modifier}`);
        const highestValueKg = shippingBar_Steps[shippingBar_Steps.length - 1].dataset.max * 1000; // in grams
        const lowestMaxValueKg = shippingBar_Steps[0].dataset.max * 1000; // in grams

        //? Logging
        // console.log(`shippingBar.dataset.weight: ${shippingBar.dataset.weight}`);

        // console.log(`totalWeightInGrams: ${totalWeightInGrams}`);
        // console.log(`highestValueKg (grams): ${highestValueKg}`);
        // console.log(`lowestMaxValueKg (grams): ${lowestMaxValueKg}`);
        //? Logging

        let message = `Fügen Sie weitere ${(lowestMaxValueKg / 1000).toFixed(2)} kg hinzu, um den Versand zu aktivieren`;

        if (totalWeightInGrams > 0 && totalWeightInGrams < lowestMaxValueKg) {
            const discInKg = ((lowestMaxValueKg - totalWeightInGrams) / 1000).toFixed(2);
            message = `Fügen Sie weitere ${discInKg} kg hinzu, um den Versand zu aktivieren`;
        } else if (totalWeightInGrams >= lowestMaxValueKg && totalWeightInGrams < highestValueKg) {
            const discInKg = ((highestValueKg - totalWeightInGrams) / 1000).toFixed(2);
            message = `Versand aktiviert! Noch ${discInKg} kg bis zum kostenlosen Versand`;
        } else if (totalWeightInGrams >= highestValueKg) {
            message = `Kostenloser Versand aktiviert!`;
        } else {
            console.log("NO CASE RETURNING TO DEFAULT");
        }

        const messageElement = document.getElementById(`shippingBar__message--${modifier}`);
        messageElement.innerText = message;

        const style = document.createElement('style');
        document.head.appendChild(style);

        shippingBar_Steps.forEach((step, index) => {
            const minValueKg = step.dataset.min * 1000; // convert to grams
            const maxValueKg = step.dataset.max * 1000; // convert to grams

            //? Logging
            // console.log(`minValueKg: ${minValueKg}`);
            // console.log(`maxValueKg: ${maxValueKg}`);
            //? Logging

            const lengthInPercent = (maxValueKg - minValueKg) / highestValueKg * 100;

            //? Logging
            // console.log(`lengthInPercent: ${lengthInPercent}`);
            //? Logging

            let beforeElementLengthInPercent = 0;

            const id = `${step.className.replace(/\s+/g, '-')}-${index}--${modifier}`;
            step.id = id;

            step.style.display = "block";
            step.style.width = `${lengthInPercent}%`;

            if (totalWeightInGrams >= maxValueKg) {
                beforeElementLengthInPercent = 100;
            } else if (totalWeightInGrams <= minValueKg) {
                beforeElementLengthInPercent = 0;
            } else if (totalWeightInGrams > minValueKg && totalWeightInGrams < maxValueKg) {
                beforeElementLengthInPercent = ((totalWeightInGrams - minValueKg) / (maxValueKg - minValueKg)) * 100;
            }

            const beforeRule = `
        #${id}>.shippingBar__step--inner::before {
            position: absolute;
            min-height: 10px;
            max-height: 10px;
            height: 10px !important;
            width: ${beforeElementLengthInPercent}%;
            background-color: #FFA400;
            border-radius: 30px;
            content: '';
            z-index: 1002;
            left: 0;
            top: 0;
        }
        `;

            style.innerHTML += beforeRule;

            if (index !== shippingBar_Steps.length - 1) {
                const cssRule = `
                #${id}::after {
                    content: "${(maxValueKg / 1000)}kg";
                    position: absolute;
                    right: -15px;
                    top: 15px;
                    color: white !important;
                    opacity: 1 !important;
                }
            `;
                // Append the CSS rule to the style element
                style.innerHTML += cssRule;
            }
        });

        const carIcon = document.querySelector(`.carIcon--${modifier}`);
        const succesIcon = document.querySelector(`.success-icon--${modifier}`);

        if (totalWeightInGrams >= highestValueKg) {
            succesIcon.classList.remove("hidden");
            carIcon.classList.add("hidden");
        } else {
            if (!succesIcon.classList.contains("hidden")) {
                succesIcon.classList.add("hidden");
            }
            if (carIcon.classList.contains("hidden")) {
                carIcon.classList.remove("hidden");
            }
        }
    }
}

customElements.define("shipping-bar", ShippingBar);
